export default __webpack_public_path__ + "static/media/ijeoma.56ff01d4.png";